import { createIntl, createIntlCache } from 'react-intl';
import {
  format as format_dateFns,
  formatDistanceToNow as formatDistanceToNow_dateFns,
  parseISO,
  differenceInSeconds,
  isPast,
} from 'date-fns';
import { enUS, es } from 'date-fns/locale';

import translations from '../../../../i18n/locales';

const ENGLISH_DEFAULT = 'en';
const DATE_FNS_LOCALES = { enUS, es };

// Define user's language. Different browsers have the user locale defined
// on different fields on the `navigator` object, so we make sure to account
// for these different by checking all of them
// Additionally, we want to fall back to a language for which translations exist.

const languages = navigator.languages || [navigator.language];

const stripRegionCode = (lang) => lang.toLowerCase().split(/[_-]+/)[0];

const languagesForWhichTranslationsExist = languages.filter((lang) => {
  const langWithoutRegionCode = stripRegionCode(lang);
  return translations[langWithoutRegionCode] || translations[lang];
});

const language = languagesForWhichTranslationsExist[0] || ENGLISH_DEFAULT;

// Split locales with a region code
export const languageWithoutRegionCode = stripRegionCode(language);

export const messages =
  translations[languageWithoutRegionCode] || translations[language];

export const locale = languageWithoutRegionCode;
export const dateFnsLocale = DATE_FNS_LOCALES[locale];

const cache = createIntlCache();

export const ccIntl = createIntl({ locale, messages }, cache);

// TODO: Add other formats (formatRelative, etc) as we need them
export const formatDate = (date, dateFormat = 'PP') => {
  return format_dateFns(date, dateFormat, {
    locale: dateFnsLocale,
  });
};

export const formatDistanceToNow = (date, options) => {
  return formatDistanceToNow_dateFns(date, {
    ...options,
    locale: dateFnsLocale,
  });
};

export const getCountAndFormattedDistanceToNow = (date, options) => {
  const formattedDistanceToNow = formatDistanceToNow_dateFns(date, {
    ...options,
    locale: dateFnsLocale,
  });
  // Use regex to match the first group of digits in the string
  const match = formattedDistanceToNow.match(/\d+/);
  const count = match ? parseInt(match[0], 10) : 1;

  return {
    count,
    formattedDistanceToNow,
  };
};

export { parseISO, isPast, differenceInSeconds };
